import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export default {
  commentContainer: {
    marginBottom: 15,
  },
  headerWrapper: {
    height: 'auto',
    overflow: 'visible',
    marginBottom: '10px',
  },
  editor: {
    width: 'calc(100% + 66.5px)',
    marginLeft: -52.5,
  },
  contentContainer: {
    paddingLeft: 45,
  },
  replyContainer: {
    paddingLeft: '10px',
  },
  edited: {
    fontSize: 16,
    color: colors.grayDark,
    marginBottom: 5,
    marginLeft: 50,
  },
  reactionsWrapper: {
    padding: '10px 0 0 45px',
  },
  createComment: {
    width: 'calc(100% - 45px)',
    marginBottom: '8px',
  },
  commentCreateWrapper: {
    paddingLeft: '45px',
    paddingTop: '13px',
    width: '100%',
  },
  commentDelimiter: {
    border: `0.5px solid ${colors.grey3}`,
  },
};
